import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import EditButton from './edit-button';
import CancelButton from './cancel-button';
import AcceptedTerms from './accepted-terms';

const isHostBookingPending = ({ booking, disableButtons, isHost, onCancel }) => {
  return (
    <Box>
      <Box style={{ marginBottom: '10px' }}>
        <AcceptedTerms booking={booking} />
      </Box>
      <EditButton {...{ booking, disableButtons }} />
      &nbsp;
      <CancelButton
        {...{
          isHost,
          onCancel,
          disableButtons,
          booking,
        }}
      />
    </Box>
  );
};

isHostBookingPending.propTypes = {
  booking: PropTypes.shape({}).isRequired,
  disableButtons: PropTypes.bool,
  isHost: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default isHostBookingPending;
